import { set } from 'cerebral/operators'
import { props, state } from 'cerebral/tags'
import loadLatest from '../actions/loadLatest'
import getCurrentFileTypes from '../actions/getCurrentFileTypes'

export default [
  set(state`media.files`, {}),
  loadLatest,
  {
    loaded: [set(state`media.files`, props`files`), getCurrentFileTypes]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/loadDefaultFiles.js